import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

interface FeatureProps {
  title: string;
  desc: string;
  features: string[];
}

const Feature: React.FC<FeatureProps> = ({ title, desc, features }) => {
  return (
    <div className="feature-container">
      <h1 className="feature-title">
        <span className="feature-title-marker"></span>
        {title}
      </h1>
      <p className="feature-desc">{desc}</p>
      <div className="feature-grid">
        {features.map((f, index) => (
          <p key={index} className="feature-element">
            <FontAwesomeIcon className="feature-check" icon={faCheck} />
            {f}
          </p>
        ))}
      </div>
    </div>
  );
};

export default Feature;
